import { api } from '@/services/api/main/axios';

export const getCountriesApiRequest = async () => {
  const res = await api.get('dictionaries/countries');
  return res.data.payload;
};

export const getTimezonesApiRequest = async () => {
  const res = await api.get('timezones');
  return res.data.payload;
};

export const getDictionaryApiRequest = async (
  dictionary: string,
  params: Record<string, unknown> = {},
): Promise<unknown> => {
  const res = await api.get<{ payload: unknown }>(`dictionaries/${dictionary}`, { params });
  return res.data.payload;
};

export const postValidateDictionaryApiRequest = async (
  dictionary: string,
  names: string[],
): Promise<unknown> => {
  const res = await api.post<{ payload: unknown }>(`dictionaries/${dictionary}`, { name: names });
  return res.data.payload;
};
